import type { api } from "@healthos/schemas";
import { useQuery } from "@tanstack/react-query";
import { client, jsonOrThrow } from "./healthos";

export const COMMUNITY_CAPABILITIES_QUERY_KEY = ["community", "capabilities"] as const;

/**
 * Single source of truth for the current user's community capabilities
 * (admin access, moderation roles). The nav badge and the /admin/community
 * route guard both read from this cache; do not inline a second copy.
 */
export function useCommunityCapabilities(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: COMMUNITY_CAPABILITIES_QUERY_KEY,
    queryFn: async () =>
      jsonOrThrow<api.CommunityCapabilitiesResponse>(
        await client().api.me.capabilities.$get(),
        "GET /api/me/capabilities",
      ),
    enabled: options.enabled ?? true,
    staleTime: 60_000,
    retry: 1,
  });
}
